import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) => state.itemsState || initialState;

export const selectItemsLoading = createSelector(
  [selectDomain],
  (itemsState) => itemsState.loading
);

export const selectItemsList = createSelector(
  [selectDomain],
  (itemsState) => itemsState.list
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (itemsState) => itemsState.isAddModalOpen
);

export const selectItemsForm = createSelector(
  [selectDomain],
  (itemsState) => itemsState.form
);

export const selectItemsSaving = createSelector(
  [selectDomain],
  (itemsState) => itemsState.saving
);

export const selectItemsError = createSelector(
  [selectDomain],
  (itemsState) => itemsState.error
);

export const selectCanSubmitItems = createSelector(
  [selectItemsForm],
  (form) => Boolean(form.item.trim())
);

export const selectItemsDetail = createSelector(
  [selectDomain],
  (itemsState) => itemsState.detail
);

export const selectItemsDetailLoading = createSelector(
  [selectDomain],
  (itemsState) => itemsState.detailLoading
);

export const selectItemsDetailError = createSelector(
  [selectDomain],
  (itemsState) => itemsState.detailError
);
